/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type CustomerType, type FileType, type MidMeterType, type ProblemDetails, type SettlementEligibility } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/export
 */
export interface ExportRequestBuilder extends BaseRequestBuilder<ExportRequestBuilder> {
    /**
     * GetCustomersExport
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<ExportRequestBuilderGetQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * GetCustomersExport
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ExportRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * GetCustomersExport
 */
export interface ExportRequestBuilderGetQueryParameters {
    affiliateCodes?: string[];
    chargerMakes?: string[];
    criteria?: string;
    customerType?: CustomerType;
    eligibility?: SettlementEligibility;
    fileType?: FileType;
    midMeters?: MidMeterType[];
    tags?: string[];
}
/**
 * Uri template for the request builder.
 */
export const ExportRequestBuilderUriTemplate = "{+baseurl}/customers/export?FileType={FileType}{&AffiliateCodes*,ChargerMakes*,Criteria*,CustomerType*,Eligibility*,MidMeters*,Tags*}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const ExportRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "affiliateCodes": "AffiliateCodes",
    "chargerMakes": "ChargerMakes",
    "criteria": "Criteria",
    "customerType": "CustomerType",
    "eligibility": "Eligibility",
    "fileType": "FileType",
    "midMeters": "MidMeters",
    "tags": "Tags",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ExportRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ExportRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        queryParametersMapper: ExportRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
